<div class="row">
  <div class="col-xs-8 col-8 col-md-5 col-lg-4 form-group">
    <input class="form-control" placeholder="Datepicker" bsDatepicker [isOpen]="isOpen"/>
  </div>
  <div class="col-xs-4 col-4 col-md-4 form-group">
    <button class="btn btn-success" (click)="isOpen = !isOpen" type="button">Toggle</button>
  </div>
</div>
